import React from 'react';
// import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
// import Media from 'react-media';
import { Formik, Field, Form } from 'formik';
import { css } from 'react-emotion';
import yup from 'yup';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
// import { connect } from 'react-redux';
// import Select from 'react-select';
import { withRouter } from 'react-router';
import { StripeProvider, Elements, injectStripe } from 'react-stripe-elements';

import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
} from 'react-stripe-elements';
import config from '../../../src/config';

// import { AuthActions } from '../../actions/auth';
// import { getActionIds } from '../../helpers/redux';
// const actions = getActionIds(AuthActions);

const test = css({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 350,
});

const sideError = css({
  display: 'block',
  fontFamily: 'arial',
  fontSize: '.875rem',
  color: '#dc3545',
});

const stripeError = css({
  fontSize: '.875rem',
  color: '#dc3545',
});

const CardField = ({ label, help, field, form, elementRef, CardElement }) => (
  <FormGroup
    render={() => (
      <div>
        <label htmlFor={field.name}>{label}</label>
        <div>
          <CardElement
            className="form-control"
            onChange={() => {
              // this is ghetto. figure out a better way later
              if (form.errors[field.name]) {
                form.setFieldError('creditcard', '');
              }
            }}
            elementRef={elementRef}
          />
          {form.errors[field.name] && (
            <div className={stripeError}>{form.errors[field.name]}</div>
          )}
        </div>
        {help && <small className="form-text text-muted">{help}</small>}
      </div>
    )}
  />
);

const schema = yup.object().shape({
  name: yup.string().required('Please enter a plan name'),
  amount: yup
    .number()
    .required('Please enter the amount in cents to be charged')
    .positive('Must be a positive number')
    .min(0, 'Minimum value is zero'),
  currency: yup.string().required('Please enter a currency'),
  interval: yup.string().required('Please select an interval'),
  interval_count: yup
    .number()
    .required(
      'Please enter the number of intervals between each subscription billing',
    )
    .positive('Must be a positive number')
    .min(1, 'Minimum value is 1'),
  meta_small: yup
    .number()
    .required('Please enter the amount of small plans')
    .positive('Must be a positive number')
    .min(0, 'Minimum value is zero'),
  meta_medium: yup
    .number()
    .required('Please enter the amount of small plans')
    .positive('Must be a positive number')
    .min(0, 'Minimum value is zero'),
  meta_large: yup
    .number()
    .required('Please enter the amount of small plans')
    .positive('Must be a positive number')
    .min(0, 'Minimum value is zero'),
});

const FormGroup = ({ render }) => <div className="form-group">{render()}</div>;

const InputField = ({
  type = 'text',
  label,
  placeholder,
  help,
  disabled,
  field,
  form,
  ...inputRest
}) => {
  return (
    <FormGroup
      render={() => (
        <div>
          <label htmlFor={field.name}>{label}</label>
          <div
            style={{
              position: 'relative',
            }}
          >
            <input
              type={type}
              className="form-control"
              aria-describedby={field.name}
              placeholder={placeholder}
              disabled={disabled}
              {...field}
              {...inputRest}
            />
            {form.errors[field.name] && (
              <div className={sideError}>{form.errors[field.name]}</div>
            )}
          </div>
          {help && <small className="form-text text-muted">{help}</small>}
        </div>
      )}
    />
  );
};

// TODO: use fragment for user
const createCustomerWithPlanAndSubscription = gql`
  mutation createCustomerWithPlanAndSubscription(
    $plan: JSON
    $payment: JSON
    $token: String!
    $organizationId: ID!
  ) {
    createCustomerWithPlanAndSubscription(
      plan: $plan
      payment: $payment
      token: $token
      organizationId: $organizationId
    ) {
      id
      payment_type
      card_brand
      card_exp_month
      card_exp_year
      card_last4
    }
  }
`;

const queryOrganizationSubscription = gql`
  query organizationSubscription($organizationId: ID!) {
    organizationSubscription(organizationId: $organizationId) {
      id
      payment_type
      card_brand
      card_exp_month
      card_exp_year
      card_last4
      #   objectable_type
      #   objectable_id
      #   user_id
      #   created_at
      #   updated_at
      #   deleted_at
      #   restored_at
      #   items {
      #     id
      #     subscription_id
      #     plan_id
      #     qty
      #     created_at
      #     updated_at
      #     restored_at
      #     deleted_at
      #   }
    }
  }
`;

const withMutation = graphql(createCustomerWithPlanAndSubscription, {
  props: ({ mutate }) => ({
    createCustomerWithPlanAndSubscription: values => {
      return mutate({
        variables: values,
        update: (
          proxy,
          { data: { createCustomerWithPlanAndSubscription } },
        ) => {
          proxy.writeQuery({
            query: queryOrganizationSubscription,
            variables: { organizationId: values.organizationId.toString() },
            data: {
              organizationSubscription: createCustomerWithPlanAndSubscription,
            },
          });
        },
        // update: (proxy, { data: { signUp } }) => {
        //   debugger;

        //   // TODO: is the user being saved correctly locally?

        //   // const query = queryNotifications;
        //   // const variables = { id: notificationId };
        //   // const data = proxy.readQuery({ query, variables });
        //   // readNotification.forEach(rn => {
        //   //   const index = data.myNotifications.findIndex(n => n.id === rn.id);
        //   //   if (index > -1) data.myNotifications.splice(index, 1);
        //   // });
        //   // proxy.writeQuery({ query, data });
        // },
        // TODO: optimisticResponse
      });
    },
  }),
});

// const formikize = graphQLErrors =>
//   graphQLErrors.reduce(
//     (p, c) => ({
//       ...p,
//       [c.path]: c.message,
//     }),
//     {},
//   );

@withRouter
@withMutation
class CreatePlanForm extends React.Component {
  render() {
    const {
      createCustomerWithPlanAndSubscription,
      closeModal,
      params: { organizationId },
    } = this.props;

    return (
      <Formik
        initialValues={{
          name: '',
          amount: '',
          currency: 'usd',
          interval: 'month',
          interval_count: 1,
          meta_small: 0,
          meta_medium: 0,
          meta_large: 0,
          payment_type: 'credit',
        }}
        validationSchema={schema}
        onSubmit={async (
          values,
          { setSubmitting, setErrors, setFieldError },
        ) => {
          setSubmitting(true);
          if (values.payment_type === 'credit') {
            try {
              const payload = await this.props.stripe.createToken();

              if (payload && payload.error) {
                console.log(payload.error);
                // STRIPE ERROR CODES: https://stripe.com/docs/api/node#errors
                switch (payload.error.code) {
                  case 'incomplete_number':
                  case 'invalid_number':
                    setFieldError('creditcard', payload.error.message);
                    break;
                  case 'incomplete_expiry':
                  case 'invalid_expiry_month':
                  case 'invalid_expiry_year':
                    setFieldError('expiration', payload.error.message);
                    break;
                  case 'incomplete_cvc':
                  case 'invalid_cvc':
                    setFieldError('cvc', payload.error.message);
                    break;
                  case 'incomplete_zip':
                  case 'incorrect_zip':
                    setFieldError('postal', payload.error.message);
                    break;
                  default:
                    setFieldError('creditcard', payload.error.message);
                }
                setSubmitting(false);
              }
              if (!payload.error) {
                const {
                  amount,
                  interval,
                  name,
                  currency,
                  payment_type,
                } = values;
                await createCustomerWithPlanAndSubscription({
                  plan: {
                    amount,
                    interval,
                    name,
                    currency,
                    payment_type,
                  },
                  payment: { cc: '1234' }, // not needed
                  token: payload.token.id,
                  organizationId,
                });
                setSubmitting(false);
                closeModal();
                // this._element.clear();
              }
            } catch (e) {
              console.log('e', e);
            }
          } else if (values.payment_type === 'check') {
            const { amount, interval, name, currency, payment_type } = values;
            await createCustomerWithPlanAndSubscription({
              plan: {
                amount,
                interval,
                name,
                currency,
                payment_type,
              },
              payment: { cc: '1234' }, // not needed
              token: 'check',
              organizationId,
            });
            setSubmitting(false);
            closeModal();
          }
          console.log('vals', values);
          setSubmitting(false);
        }}
        render={({ values, setFieldValue, isSubmitting }) => (
          <Form className={test} ref={node => (this.form = node)}>
            <Field component={InputField} name="name" label="Plan Name" />
            <Field
              component={InputField}
              name="amount"
              label="Amount"
              type="number"
              min="1"
              max="99999999"
            />
            <Field
              component={InputField}
              name="currency"
              label="Currency"
              disabled
            />
            <div style={{ marginBottom: 16 }}>
              <label htmlFor="interval">Interval</label>
              <Field
                name="interval"
                component="select"
                className="form-control"
                onChange={v => {
                  setFieldValue('interval', v);
                }}
              >
                <option value="day">day</option>
                <option value="week">week</option>
                <option value="month">month</option>
                <option value="year">year</option>
              </Field>
              {/* <Field
            component={Select}
            name="interval"
            label="Interval"
            value={values.interval}
            searchable={false}
            simpleValue
            options={[
              { value: 'day', label: 'day' },
              { value: 'week', label: 'week' },
              { value: 'month', label: 'month' },
              { value: 'year', label: 'year' },
            ]}
            onChange={v => {
              setFieldValue('interval', v);
            }}
          /> */}
            </div>
            <Field
              component={InputField}
              name="interval_count"
              label="Interval Count"
              type="number"
              min="1"
            />
            <Field
              component={InputField}
              name="meta_small"
              label="Small"
              type="number"
              min="0"
            />
            <Field
              component={InputField}
              name="meta_medium"
              label="Medium"
              type="number"
              min="0"
            />
            <Field
              component={InputField}
              name="meta_large"
              label="Large"
              type="number"
              min="0"
            />
            <div style={{ marginBottom: 16 }}>
              <label htmlFor="payment_type">Payment Type</label>
              <Field
                name="payment_type"
                component="select"
                className="form-control"
                onChange={v => {
                  setFieldValue('payment_type', v);
                }}
              >
                <option value="credit">Credit</option>
                {/* <option value="ach">ACH</option> */}
                <option value="check">Check</option>
              </Field>
            </div>
            {values.payment_type === 'credit' && [
              <Field
                key="creditcard"
                label="Credit Card"
                component={CardField}
                CardElement={CardNumberElement}
                name="creditcard"
                elementRef={c => (this._element = c)}
              />,
              <Field
                key="expiration"
                label="Expiration date"
                component={CardField}
                CardElement={CardExpiryElement}
                name="expiration"
                elementRef={c => (this._element = c)}
              />,
              <Field
                key="cvc"
                label="CVC"
                component={CardField}
                CardElement={CardCVCElement}
                name="cvc"
                elementRef={c => (this._element = c)}
              />,
              <Field
                key="postalcode"
                label="Postal Code"
                component={CardField}
                CardElement={PostalCodeElement}
                name="postalcode"
                elementRef={c => (this._element = c)}
              />,
            ]}
            <div className="form-group row">
              <button
                className="btn btn-primary"
                type="submit"
                disabled={isSubmitting}
                style={{ marginRight: 10 }}
              >
                {!isSubmitting && 'Create Plan'}
                {isSubmitting && (
                  <span>
                    <i className="fa fa-spinner fa-pulse fa-fw" /> Creating
                    plan...
                  </span>
                )}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </Form>
        )}
      />
    );
  }
}

const InjectedCreatePlanForm = injectStripe(CreatePlanForm);
class CreatePlanButton extends React.Component {
  state = {
    open: false,
  };

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    // const { stripe } = this.props;
    return (
      <div>
        <button className="btn btn-primary" onClick={this.handleClick}>
          Create a Plan
        </button>
        <CreatePlanModal
          showModal={this.state.open}
          handleCloseModal={this.handleClose}
          contentLabel={'Create a Plan'}
        />
      </div>
    );
  }
}

class CreatePlanModal extends React.Component {
  render() {
    const { showModal, contentLabel, handleCloseModal } = this.props;
    return (
      <ReactModal
        isOpen={showModal}
        contentLabel={contentLabel}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            overflowY: 'auto',
          },
          content: {
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: 0,
            border: 'none',
            bottom: 'auto',
            borderRadius: 4,
            maxWidth: '40vw',
          },
        }}
      >
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#eee' }}>
            <h5 className="modal-title">{contentLabel}</h5>
            <button
              onClick={handleCloseModal}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i
                className="fa fa fa-times"
                style={{ fontSize: '1.3em', color: '#808080' }}
              />
            </button>
          </div>
          <div className="modal-body">
            <StripeProvider apiKey={config.stripeKey.public}>
              <Elements>
                <InjectedCreatePlanForm closeModal={handleCloseModal} />
              </Elements>
            </StripeProvider>
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default CreatePlanButton;



// WEBPACK FOOTER //
// ./src/views/Admin/CreatePlan.js